import ReactDOM from 'react-dom/client'
import { init } from '@telegram-apps/sdk-react'
import App from './App.tsx'
import './index.css'
import 'leaflet/dist/leaflet.css'

// Initialize Telegram SDK
try {
  init()
} catch (error) {
  console.warn('Failed to initialize Telegram SDK:', error)
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <App />
)